export default __webpack_public_path__ + "static/media/MBS.7925a012.pdf";